import { render, staticRenderFns } from "./MigrasiSurat.vue?vue&type=template&id=2856f4e3&scoped=true"
import script from "./MigrasiSurat.vue?vue&type=script&lang=js"
export * from "./MigrasiSurat.vue?vue&type=script&lang=js"
import style0 from "./MigrasiSurat.vue?vue&type=style&index=0&id=2856f4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856f4e3",
  null
  
)

export default component.exports